import * as React from "react";
import { FrameMeasurements } from "./FrameMeasurements.js";
import { useProductWithAFrameData } from "../../../../../../context/context/product-context-hooks.js";
const FrameMeasurementsContainer = () => {
  const {
    activeVariant: { frameMeasurements }
  } = useProductWithAFrameData();
  if (!frameMeasurements) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(FrameMeasurements, { measurements: frameMeasurements });
};
export {
  FrameMeasurementsContainer
};
//# sourceMappingURL=FrameMeasurementsContainer.js.map
